<template>
  <v-container grid-list-xs>
    <div class="privacyTitle">Нууцлал ба бодлого</div>
    <div v-for="(item,i) in items" :key="i" style="margin-top:20px">
      <div class="title">{{item.title}}</div>
      <div class="desc">{{item.desc}}</div>
      <ol v-if="item.list">
        <li v-for="(list,i) in item.list" :key="i" class="list">{{list}}</li>
      </ol>
    </div>
    <div class="endStyle">Энэ нууцлалын бодлого 2020-05-17 өдрөөс эхлэн үйлчилнэ.</div>
  </v-container>
</template>
<script>
  export default {
    name: "privacy",
    data() {
      return {
        items: [
          {
            title: "БИД ХЭН БЭ?",
            desc:
              "Энэхүү веб хуудсыг (https://www.chimege.mn) “Чимэгэ системс” ХХК ажиллуулж байгаа бөгөөд “Чимэгэ системс”-ийн бүх бүтээгдэхүүний арчилгаа үйлчилгээг хийдэг. Тус веб хуудас нь таны хувийн аюулгүй байдлыг чухалчлах бодлогыг баримтална. Энэ бодлого www.chimege.mn хуудас хэрэглэгчдийн мэдээлэлтэй хэрхэн харьцахыг тодорхойлно. Манай веб хуудсаар зочилсноор таныг нууцлалын бодлогыг зөвшөөрсөн гэж үзэх болно."
          },
          {
            title: "БИДНИЙ ЦУГЛУУЛАХ МЭДЭЭЛЭЛ",
            desc: "Бид зөвхөн дараах хоёр төрлийн хувийн мэдээллийг авдаг.",
            list: [
              "Холбогдох мэдээлэл. Та манай харилцах маягтаар Нэр болон Цахим шуудангийн хаягаа өгч холбогдсон бол бидэнд энэ мэдээлэл ирнэ.",
              "Энэхүү веб хуудас болон түүний апп бидний хөгжүүлж буй дуу ярианы технологийн дэвшлийг үзүүлэх зорилготой. Тиймээс, яриаг бичвэрт буулгах системийг туршиж үзэхийн тулд таны бичлэг манай сервер рүү илгээгдэх шаардлагатай.",
              "Таны сонгосон файлыг хөрвүүлэхийн тулд Апп таны диск рүү хандах эрх нэхнэ."
            ]
          },
          {
            title: "КҮҮКИЙ",
            desc:
              "Күүкий нь таныг бусад хэрэглэгчээс ялгах жижигхэн өгөгдлийг агуулсан интернэт хөтчийн санах ой эсвэл дискт хадгалсан файл юм. Бид хэрэглэгчдийг найдвартай нэвтрүүлэхийн тулд Күүкий ашиглана"
          },
          {
            title: "АЮУЛГҮЙ БАЙДАЛ",
            desc:
              "Бид таны илгээсэн хувийн өгөгдлийг бат итгэлтэй хадгалах ёстой гэдгээ бүрэн ухамсарласны үндсэн дээр арилжааны түвшинд хамгаалах хэрэгслийг ашиглаж байгаа болно. Гэсэн хэдий ч 100% баталгаатай цахим хэлбэрээр хадгалах болон интернэтээр дамжуулах арга байхгүй юм. Тиймээс бид танд бүрэн төгс баталгааг олгох боломжгүй."
          },
          {
            title: "ТАНЫ ХУВИЙН ӨГӨГДЛИЙГ ХУВААЛЦАХ ЭСЭХ",
            desc:
              "Бид таны хувийн өгөгдлийг зарах болон хэн нэгэнтэй хуваалцахгүй."
          },
          {
            title: "ДОТООД БОДЛОГО",
            desc:
              "Бид энэ мэдээллийн аюулгүй байдалтай холбоотой нууцлалын бодлогыг байнга хянаж, сайжруулан шинэчилж байх болно.Асуулт ба хүсэлт. Хэрэв танд энэхүү нууцлалын бодлоготой холбоотой санал хүсэлт, асуулт, эсвэл таны эрх зөрчигдөж байна гэж үзэх ямар нэгэн заалт байвал info at chimege dot mn хаягаар холбогдоно уу."
          }
        ]
      };
    }
  };
</script>
<style scoped>
  .privacyTitle {
    color: #2c3e50;
    font-weight: 500;
    line-height: 1.5;
    font-size: 22px;
    margin-top: 20px;
    text-transform: uppercase;
  }

  .title {
    color: #2c3e50;
    font-weight: 500;
    line-height: 1.5;
    font-size: 18px;
    text-align: left;
  }

  .desc {
    text-align: justify;
    line-height: 1.5;
    font-size: 16px;
    color: #2c3e50;
    margin-top: 10px;
  }

  .list {
    text-align: left;
    margin: 10px 0 0 30px;
  }

  .endStyle {
    text-align: justify;
    line-height: 1.5;
    font-size: 16px;
    color: #2c3e50;
    margin: 40px 0;
  }
</style>